import { jwtDecode } from "jwt-decode";

const PANEL_API_URL = (process.env.NODE_APP_PANEL_URL || "").replace(/\/$/, "");

export const pushReportToDashboard = async (reportMetadata) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${PANEL_API_URL}/reports`,
       {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        reportType: reportMetadata.reportType,
        generatedAt: reportMetadata.generatedAt,
        fileName: reportMetadata.fileName,
        parameters: reportMetadata.parameters,
        storage_path: reportMetadata.storage_path
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Error en el servidor");
    }
    
    return await response.json();
  } catch (error) {
    console.error("Error registrando el informe:", error);
    throw error;
  }
};

export const getUserData = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return {
      userId: decoded.id,
      companyId: decoded.company_id,
    };
  } catch (error) {
    console.error("Error decodificando el token", error);
    return null;
  }
};

export const chunkArray = (array, size) => {
  const results = [];
  for (let i = 0; i < array.length; i += size) {
    results.push(array.slice(i, i + size));
  }
  return results;
};

export const applyFormat = (format) => {
  const textarea = document.getElementById('customContentEditor');
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;
  const text = textarea.value;
  const before = text.substring(0, start);
  const selected = text.substring(start, end);
  const after = text.substring(end);
  
  let formattedText = '';
  switch(format) {
    case 'bold':
      formattedText = `**${selected}**`;
      break;
    case 'italic':
      formattedText = `_${selected}_`;
      break;
    case 'bullets':
      formattedText = `• ${selected.replace(/\n/g, '\n• ')}`;
      break;
    default:
      formattedText = selected;
  }
  
  return { formattedText, before, after };
};